$(function() {
  var trainingPage = $('.trainings-controller-index');

  if (trainingPage.length > 0) {
    var trainingForm = $('.training-search-form');
    var trainingResults = $('.training-search__results');

    var trainingRegionSelect = $('.trainings__region-select');

    trainingForm.on('ajax:success', function(event) {
      const data = event.detail[2].responseText;
      trainingResults.html(data);
    }).on('ajax:error', function(event) {
      // alert('error');
    });

    trainingRegionSelect.on('change', function(event) {
      Rails.fire(trainingForm[0], 'submit');
    });
  }

  var trainingDetailPage = $('.trainings-controller-show, .trainings-controller-contact_form');

  if (trainingDetailPage.length > 0 ) {
    $('.training-hero__apply_btn').on('click', function(event) {
      event.preventDefault();
      $('.training-form__container').slideToggle(400, function() {
        ga('send', 'event', 'Training Apply Form', ($(this).is(':visible') ? 'open' : 'close'));
      });
      selectize_all_selects();
      FormDisclaimer.disclaimerHandler();
    });

    $('.training__contact-button').on('click', function(event) {
      event.preventDefault();
      $('.training__contact-form').slideToggle();
      FormDisclaimer.disclaimerHandler();
      selectize_all_selects();
    })
  }

});
